import script from "./Splines.vue?vue&type=script&lang=js"
export * from "./Splines.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__